var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStakingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 23H8C5.24 23 3 20.76 3 18V2C3 1.45 2.55 1 2 1C1.45 1 1 1.45 1 2V18C1 21.86 4.14 25 8 25H24C24.55 25 25 24.55 25 24C25 23.45 24.55 23 24 23ZM6.58 16.89C6.84 16.89 7.09 16.79 7.29 16.6L11.89 12C12.02 11.87 12.17 11.85 12.24 11.85C12.31 11.85 12.47 11.87 12.59 12L14 13.41C14.97 14.38 16.56 14.38 17.54 13.41L22.14 8.81C22.53 8.42 22.53 7.79 22.14 7.4C21.75 7.01 21.12 7.01 20.73 7.4L16.13 12C16 12.13 15.85 12.15 15.78 12.15C15.71 12.15 15.55 12.13 15.43 12L14.02 10.59C13.05 9.62 11.46 9.61 10.48 10.59L5.88 15.19C5.49 15.58 5.49 16.21 5.88 16.6C6.08 16.8 6.33 16.89 6.59 16.89H6.58Z",
    fill: "hsla(200, 53%, 23%, 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakingActive);
export default __webpack_public_path__ + "static/media/staking_active.45b18228703d49e2cf209cf57e35ee80.svg";
export { ForwardRef as ReactComponent };